import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
//import i18n from './i18n';
import './i18n';  

// ────────────────────────────────────────────────────────────────────────────
// Google Analytics ya está cargado en el HTML, no duplicar aquí
// ────────────────────────────────────────────────────────────────────────────

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
